<div *ngIf="!hideOnZero || counter > 0" class="rounded-full px-2 py-1 bg-red-500 text-white text-sm">
  {{ counter }}
</div>